/* eslint-disable indent */

    var trackingUtils = require('../../modules/utils/tracking.utils.js');
    var filterMixin = require('./utils/filter.mixin.js');
    var filterViewMixin = require('./utils/filter.view.mixin');
    var filterModelProps = require('./utils/model_props');
    var filterModelMixin = require('./utils/filter.model.mixin.js');

    Odigeo.defineWidget('stopover_quantity_filter', Odigeo.Widget.extend(Odigeo._.defaults({
        modelClass: Odigeo.Model.extend(Odigeo._.defaults({
            modelProps: filterModelProps.stopoverQuantity,
            getRequestModel: function(idx) {
                return {
                    maxStops: this.widget.view.$el.find('input[type=radio][name=stopGroup' + idx + ']:checked').val(),
                };
            },
            bindEvents: function() {
                this.listenTo(this, 'change:maxStopoversSelected', this.triggerChangeMaxStopoversSelected);
            },
            triggerChangeMaxStopoversSelected: function(model, value) {
                Odigeo.trigger(this.widget.name + ':change-max-stops-selected', model.get('idx'), value);
            },
            isFilterApplied: function() {
                return this.get('maxStopoversSelected') !== Infinity;
            },
            getTagInfo: function() {
                return {
                    maxStopoversSelected: this.get('maxStopoversSelected'),
                };
            },
        }, filterModelMixin)),

        viewClass: Odigeo.View.extend(Odigeo._.defaults({
            resetFilter: function() {
                this.model.set('maxStopoversSelected', Infinity);
                this.$widget.find('#dontMindRadio' + this.model.get('idx')).prop('checked', true);
                this.model.filterRequest(['stops']);
            },
            initFilter: function() {
                var $cachedSelectors = this.$cachedSelectors;
                Odigeo._.each($cachedSelectors.labels, function(label, index) {
                    this.initRadio($(label), $($cachedSelectors.inputs[index]));
                }, this);
                this.model.set('maxStopoversSelected', Infinity);
                this.$widget.find('#dontMindRadio' + this.model.get('idx')).prop('checked', true);
                this.setIsFiltered();
            },
            initRadio: function($label, $input) {
                const minStops = this.model.get('minStops');
                const maxStops = this.model.get('maxStops');
                const options = this.widget.options;
                const translations = options.translations;
                const stopoverIndex = +$input.val();
                if (Odigeo._.includes([0, 1, 2], stopoverIndex)) {
                    let stopoverText = [translations.fromStopoversText[stopoverIndex]];
                    let labeltext = null;
                    if (minStops > stopoverIndex || maxStops < stopoverIndex) {
                        $input.prop('disabled', true);
                        stopoverText.push(translations.notAvailable || '');
                    }

                    if (!Odigeo.AB.isCssVariationMobile && !Odigeo.SessionScope.isMetaFlights) {
                        if (!options.tests.isFilterLayerEnabled) {
                            labeltext = stopoverText.join(' ');
                        } else {
                            labeltext = `
                        <span class="odf-selectable-input odf-radio-back  odf-space-outer-right-s">
                            <span class="odf-selectable-fill odf-radio-fill"></span>
                        </span>
                        <span>${stopoverText.join(' ')}</span>`;
                        }
                    } else {
                        if (!options.tests.isFilterLayerEnabled && !Odigeo.SessionScope.isMetaFlights) {
                            labeltext = stopoverText.join(' ');
                        } else {
                            labeltext = `
                        <span class="prisma-selectable-input prisma-radio-back  odf-space-outer-right-s">
                            <span class="prisma-selectable-fill prisma-radio-fill">
                                <span class="odf-icon odf-icon-tick"></span>
                            </span>
                        </span>
                        <span class="${Odigeo.SessionScope.isMetaFlights ? 'odf-text-md' : ''}">${stopoverText.join(' ')}</span>`;
                        }
                    }
                    $label.html(labeltext);
                }
            },
            onFilter: function(params) {
                var maxStopsSelected = parseInt(params.stop, 10);
                this.model.set('maxStopoversSelected', maxStopsSelected === -1 ? Infinity : maxStopsSelected);
                this.model.filterRequest(['stops']);
                if (!params.skipTracking) {
                    trackingUtils.trackEvent('results_filters', 'stops_numb_' + (maxStopsSelected === -1 ? 'DM' : maxStopsSelected));
                }
                Odigeo.trigger(this.widget.name + ':stopsFilterChanged', {numStops: maxStopsSelected});
                this.setIsFiltered();
            },
            setIsFiltered: function() {
                var idx = this.model.get('idx');
                Odigeo.trigger(
                    this.widget.widgetType + ':filtersUpdated',
                    idx,
                    this.widget.name,
                    Odigeo._.isFinite(this.model.get('maxStopoversSelected'))
                );
            },
            selectors: {
                labels: '.filter_label',
                inputs: '.filter_input',
            },
        }, filterViewMixin)),

        bindEvents: function() {
            this.listenTo(this.model, 'change:maxStopoversSelected', this.triggerFilterChange);
        },

        doCheckNonStopsFilter: function(param) {
            var idx = param.tabId;
            this.rebuildWidgetIfNeeded(idx);
            this.view.$widget.find('#radio-from-0-stopovers-' + idx).prop('checked', true);
            this.onFilter(param);
        },

        filterType: 'stopover-quantity',
    }, filterMixin)));
